function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M84.0567 63.75H32.8915C30.8741 63.75 29.2368 62.07 29.2368 60C29.2368 57.93 30.8741 56.25 32.8915 56.25H84.0567C86.0741 56.25 87.7114 57.93 87.7114 60C87.7114 62.07 86.0741 63.75 84.0567 63.75Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.475 90C56.4576 90 54.8203 88.32 54.8203 86.25V33.75C54.8203 31.68 56.4576 30 58.475 30C60.4924 30 62.1296 31.68 62.1296 33.75V86.25C62.1296 88.32 60.4924 90 58.475 90Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M103.548 120H13.4007C6.00842 120 0 113.835 0 106.25V13.7503C0 6.16516 6.00842 0 13.4007 0H103.548C110.941 0 116.949 6.16516 116.949 13.7503V106.25C116.949 113.835 110.941 120 103.548 120ZM13.4007 7.5C10.0432 7.5 7.30932 10.3052 7.30932 13.7503V106.25C7.30932 109.695 10.0432 112.5 13.4007 112.5H103.548C106.906 112.5 109.64 109.695 109.64 106.25V13.7503C109.64 10.3052 106.906 7.5 103.548 7.5H13.4007Z"
});

function SvgAddArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 120,
    viewBox: "0 0 117 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddArticle);
export default __webpack_public_path__ + "static/media/add_article.e152f824.svg";
export { ForwardRef as ReactComponent };